module.exports = __webpack_public_path__ + "static/banner-printers-mobile-b60720716e10f84c0752bd7cb19ad092.png";